import {
  SET_LOGIN,
  SET_LOGOUT,
  SET_RECAPTCHA_CODE_STATE,
} from "../../actions-Types/authActionTypes";

interface LoginDetails {
  email?: string;
  password?: string;
  username?: string;
}

interface AuthState {
  loginDetials: LoginDetails | null;
  recaptchaCode: string | null;
}

// Action types for reducer
type AuthAction =
  | { type: typeof SET_LOGIN; payload: LoginDetails }
  | { type: typeof SET_LOGOUT }
  | { type: typeof SET_RECAPTCHA_CODE_STATE; payload: string };

const initialState: AuthState = {
  loginDetials: null,
  recaptchaCode: null,
};

const authReducer = (
  state: AuthState = initialState,
  action: AuthAction
): AuthState => {
  switch (action.type) {
    case SET_LOGIN:
      return { ...state, loginDetials: action.payload };
    case SET_LOGOUT:
      return { ...state, loginDetials: null };
    case SET_RECAPTCHA_CODE_STATE:
      return { ...state, recaptchaCode: action.payload };
    default:
      return state;
  }
};

export default authReducer;
